import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APPEND_TOKEN, PLATFORM } from 'src/app/constants';
import { environment } from 'src/environments/environment';
import { WelcomeScreensResponse } from 'src/app/views/welcome/interfaces';

export interface FAQs {
  data: {
    id: number;
    attributes: {
      faqs: {
        id: number;
        question: string;
        answer: string;
      }[];
    };
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class AppService {
  patform = PLATFORM.WEB_APP;
  city = '';
  pincode = '';

  constructor(private httpClient: HttpClient, private router: Router) {}

  getHomePageFAQs() {
    return this.httpClient.get<FAQs>(
      `${environment.cmsHost}/api/home-page-faqs?populate=*`,
      {
        context: new HttpContext().set(APPEND_TOKEN, false)
      }
    );
  }

  getWelcomeScreens() {
    return this.httpClient.get<WelcomeScreensResponse>(
      `${environment.cmsHost}/api/welcome-screens?populate=*`,
      {
        context: new HttpContext().set(APPEND_TOKEN, false)
      }
    );
  }

  detectDeviceType(): string {
    const width = window.innerWidth;
    if (width <= 768) {
      return 'smartphone';
    } else {
      return 'desktop';
    }
  }

  setPlatform(platform: PLATFORM) {
    this.patform = platform;
  }

  getPlatform() {
    return this.patform;
  }

  setCity(city: string) {
    this.city = city;
  }

  setPincode(pincode: string) {
    this.pincode = pincode;
  }

  getCity() {
    return this.city;
  }

  getPincode() {
    return this.pincode;
  }

  redirectToRetailIDAMSignup(fallbackRoute: string[] = ['/sign-in']) {
    const clientId = environment.clientIdForRetailIDAM;
    const retailIDAMURL = environment.retailIDAMURL;
    const returnUIURL = `${window.location.origin}/auth/callback`;

    if (!clientId || !retailIDAMURL) {
      this.router.navigate(fallbackRoute).catch(() => {});
    } else {
      document.location.href = `${retailIDAMURL}/sign-up?client_id=${clientId}&return_ui_url=${returnUIURL}`;
    }
  }
}
